import type { ComponentType } from "react";
import AvailableNodesPanel from "../panels/available-nodes/available-nodes-panel";
import { NodePropertiesPanel } from "../panels/node-properties/node-properties-panel";
import { ValidationErrorsPanel } from "../panels/validation-errors/validation-errors-panel";

export const PANEL_COMPONENTS: Record<
  "node-properties" | "available-nodes" | "validation-errors" | "none",
  ComponentType
> = {
  "available-nodes": AvailableNodesPanel,
  "node-properties": NodePropertiesPanel,
  "validation-errors": ValidationErrorsPanel,
  none: () => null,
};
